<template>
  <div class="general-page">
    <h1>SMS Login</h1>

    <p>Enter the <b>4 digit code</b> we just text you. It may take a few minutes to arrive.</p>
    <div class="qform2022 full">
      <p
        v-if="first(errors) || errors.recaptcha_response"
        class="notice error live"
      >
        <span class="icon-attention redicon" />
        {{ first(errors) }}
      </p>

      <template v-if="first(errors) && first(errors).includes('expire')">
        <router-link
          class="button"
          :to="{ name: 'sms-login' }"
        >
          Request a new code
        </router-link>
      </template>
      <form
        v-else
        @submit.prevent="post"
      >
        <div class="generic-inputs">
          <label>SMS Code*</label>
          <input
            v-model="code"
            type="number"
            name="code"
            placeholder="Code"
          >
        </div>

        <div v-if="recaptchaFields.required">
          <vue-recaptcha
            ref="recaptcha"
            :sitekey="recaptchaKey"
            @verify="recaptchaCompleted"
          />
          <br>
        </div>

        <div
          v-if="loading"
          class="twobuttons"
        >
          <img
            src="/assets/images/loading.gif"
            style="width:200px;"
          >
        </div>
        <div
          v-else
          class="twobuttons"
        >
          <button class="button">
            Submit
          </button>
          <span>or</span>
          <button
            class="button clear"
            onclick="event.preventDefault(); location.href='/contact-us'"
          >
            Contact us instead
          </button>
        </div>
      </form>
    </div>
    <br>
    <p class="last">
      <a
        href="/portal"
        class="normal-link"
      >Create an account</a> if you don't have one.
    </p>
  </div>
</template>

<script>
import { ref } from 'vue';
import authComposable from "./AuthComposable.js";
import axios from '../../axios.js'
import {VueRecaptcha} from "vue-recaptcha";
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
    components: {
        VueRecaptcha
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const loading = ref(false);
        const code = ref(null);
        const errors = ref([]);
        const store = useStore();
        const { recaptchaFields, resetCaptcha, recaptchaKey, first, recaptchaCompleted } = authComposable();

        const post = () => {
            loading.value = true;
            errors.value = [];

            let data = {
                code: code.value,
                recaptcha_response: recaptchaFields.response,
            };

            if (!route.query.route) {
                errors.value = { general: ['Your session has timed out.'] };
                loading.value = false;
                return false;
            }

            axios({
                method: 'post',
                url: atob(route.query.route),
                data: data
            }).then(response => {
                    if (!response.data.success) {
                        errors.value = response.data.errors;
                    } else if (response.data.redirect) {
                        window.location = response.data.redirect;
                    } else {
                        store.commit('setSmsLoginUsers', response.data.users);
                        router.push({
                            name: 'sms-login-pick',
                            query: {
                                route: btoa(response.data.route),
                            },
                        });
                    }

                    if (errors.value.recaptcha_response) {
                        recaptchaFields.required = true;
                    }

                    loading.value = false;
                })
                .catch(() => {
                    errors.value = { general: ['Something went wrong; please try again later.'] };
                    loading.value = false;
                })
                .then(() => {
                    resetCaptcha();
                });
        };

        return {
            loading,
            code,
            errors,
            post,
            recaptchaFields,
            recaptchaKey,
            first,
            recaptchaCompleted
        };
    },
};
</script>
